// frontend/src/services/users.ts

import api from "./api";

export interface User {
  id: number;
  username: string;
  nome: string;
  cognome: string;
  email: string;
  specializzazione: string;
  struttura: string;
  isAdmin: boolean;
  canDownload: boolean;
  created_at: string;
  is_active: boolean;
}

export interface CreateUserData {
  nome: string;
  cognome: string;
  email: string;
  specializzazione: string;
  struttura: string;
}

export interface UserWithCredentials extends User {
  credentials: {
    username: string;
    password: string;
  };
}

export const getUsers = async () => {
  try {
    const response = await api.get<{
      success: boolean;
      data: Array<
        User & {
          candownload?: boolean;
        }
      >;
    }>("/users");

    const normalizedUsers = response.data.data.map((user) => ({
      ...user,
      canDownload: user.candownload ?? user.canDownload,
    }));

    return {
      ...response.data,
      data: normalizedUsers,
    };
  } catch (error) {
    throw error;
  }
};

export const createUser = async (userData: CreateUserData) => {
  try {
    const response = await api.post<{
      success: boolean;
      data: UserWithCredentials;
    }>("/users", userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleUserStatus = async (userId: number) => {
  try {
    const response = await api.patch<{
      success: boolean;
      data: { id: number; is_active: boolean };
    }>(`/users/${userId}/toggle-status`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleUserDownload = async (userId: number) => {
  try {
    const response = await api.patch<{
      success: boolean;
      data: {
        id: number;
        canDownload: boolean;
        is_active: boolean;
      };
    }>(`/users/${userId}/toggle-download`);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId: number) => {
  try {
    const response = await api.delete<{
      success: boolean;
      data: { id: number };
    }>(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default api;
